import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router';

import { filtersToOptions } from './api/utils/filters-to-options';

const filterRegex = /filter\[(.*)\]/;

export const useFilterQuery = () => {
  const query = useQuery();

  /*
  filter[name]=wa&page=1&page[number]=1&page[size]=20&size=10&sort=-updated_at
   */
  const page = query.get('page[number]');
  const size = query.get('page[size]');
  const sort = query.get('sort');

  const include = query.get('include');
  return useMemo(() => {
    const filter = Array.from(query.entries()).reduce((acc, [key, value]) => {
      if (key.startsWith('filter') && !!value) {
        acc[key] = value;
        // const filterName = filterRegex.exec(key)?.[1]
        // if (filterName) {
        //   acc[filterName] = value
        // }
      }
      return acc;
    }, {} as any);

    return {
      page: page ?? 0,
      size: size ?? 10,
      sort,
      include,
      ...filter,
    };
  }, [query]);
};

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}
